import React, { useEffect, useState } from 'react'
import { fetchLocutorName } from '../../pages/FetchUpdateUserData';
import { useTranslation } from 'react-i18next';
import LoadingElement from './LoadingElement';

export const BankEl = ({ walletInfo }) => {
    const [userName, setUserName] = useState('');
    const { t } = useTranslation();

    const bankName = async (id) => {
        try {
            const data = await fetchLocutorName(id);        
            return data.fname + " " + data.lname;
        } catch (error) {
            console.error('Помилка при отриманні імені:', error);
            return t("Error retrieving name");
        }
    }

    useEffect(() => {
        if (walletInfo?.bankInfo) {
            bankName(walletInfo.bankInfo.user)
                .then((name) => {
                    setUserName(name);
                })
                .catch((error) => {
                    console.error('Помилка при отриманні імені:', error);
                    setUserName(t("Error retrieving name"));
                });
        } else {
           
            setUserName(t("This wallet has been deleted"));
        }
    }, [walletInfo, t]);

    return <h3 style={{ textAlign: "left" }}>{userName || <LoadingElement mini={true} />}</h3>;
}
